import { BrandMark } from '@pa/ui'
import { Stethoscope } from 'lucide-react'
import { BookingApp } from '@/features/booking'
import { useClinicConfig, type LinkParams } from '@/features/clinic'

/**
 * The direct link `/c/{slug}` (Frontend §4.1): the mockup's `patient/Frame.tsx` page chrome (header and footer,
 * without the demo bar) around the booking flow.
 */
export function DirectPage({ slug, link }: { slug: string; link: LinkParams }) {
  const name = useClinicConfig(slug).data?.clinic.name
  return (
    <div className="pt">
      <header className="pt-header">
        <span className="pt-logo">
          <BrandMark />
        </span>
        <div>
          {name !== undefined && <b>{name}</b>}
          <span>Online scheduling</span>
        </div>
      </header>
      <main className="pt-main">
        <BookingApp slug={slug} link={link} />
      </main>
      {name !== undefined && (
        <footer className="pt-foot">
          <Stethoscope size={12} aria-hidden /> Appointments are booked directly into <b>{name}</b>’s calendar.
        </footer>
      )}
    </div>
  )
}
